//Routes defined here

import menuHtml from './templates/menu.html'
import frontHtml from './templates/front.html'
import todayHtml from './templates/today.html'
import newsHtml from './templates/news.html'
import accountHtml from './templates/account.html'
import registrationHtml from './templates/registration.html'
import userdetailsHtml from './templates/userdetails.html'
import logHtml from './templates/log.html'
import fitnessHtml from './templates/fitness.html'
import showeventHtml from './templates/showevent.html'

export default {
    'app': {
        url: '/app',
        abstract: true,
        cache: false,
        templateUrl: menuHtml,
        controller: 'AppCtrl'
    },
    'app.front': {
        url: '/front',
        views: {
            'tab-1': {
                templateUrl: frontHtml,
                controller: 'FrontCtrl'
            }
        }
    },
    'app.today': {
        url: '/today',
        views: {
            'tab-3': {
                templateUrl: todayHtml,
                controller: 'TodayCtrl'
            }
        }
    },
    'app.news': {
        url: '/news/:articleId',
        views: {
            'tab-3': {
                templateUrl: newsHtml,
                controller: 'NewsCtrl'
            }
        }
    },
    'app.news2': {
        url: '/news2/:articleId',
        views: {
            'tab-3': {
                templateUrl: newsHtml,
                controller: 'NewsCtrl'
            }
        }
    },
    'app.account': {
        url: '/account',
        views: {
            'tab-4': {
                templateUrl: accountHtml,
                controller: 'AccountCtrl'
            }
        }
    },
    'app.registration': {
        url: '/registration',
        params: { mode: 'registration' },
        views: {
            'tab-5': {
                templateUrl: registrationHtml,
                controller: 'UserCtrl'
            }
        }
    },
    'app.userdetails': {
        url: '/userdetails',
        params: { mode: 'userdetails' },
        views: {
            'tab-4': {
                templateUrl: userdetailsHtml,
                controller: 'UserCtrl'
            }
        }
    },
    'app.log': {
        url: '/log',
        views: {
            'tab-6': {
                templateUrl: logHtml,
                controller: 'LogCtrl'
            }
        }
    },
    'app.fitness': {
        url: '/fitness/:fitnessCategoryId',
        views: {
            'tab-7': {
                templateUrl: fitnessHtml,
                controller: 'FitnessCtrl'
            }
        }
    },
    'app.showevent': {
        url: '/showevent',
        params: {
            activityId: null
        },
        views: {
            'tab-7': {
                templateUrl: showeventHtml,
                controller: 'ShowEventCtrl'
            }
        }
    }
}